import apiClient from './config';

export const getServicios = (params) => apiClient.get('/servicios', { params });
export const getServicio = (id) => apiClient.get(`/servicios/${id}`);
export const createServicio = (data, imagen) => {
  const formData = new FormData();
  
  // Agregar los campos de texto
  Object.keys(data).forEach(key => {
    formData.append(key, data[key]);
  });
  
  // Agregar la imagen si existe
  if (imagen) {
    formData.append('imagen', imagen);
  }
  
  return apiClient.post('/servicios', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const updateServicio = (id, data, imagen) => {
  const formData = new FormData();
  
  // Agregar los campos de texto
  Object.keys(data).forEach(key => {
    formData.append(key, data[key]);
  });
  
  // Agregar la imagen si existe
  if (imagen) {
    formData.append('imagen', imagen);
  }
  
  return apiClient.put(`/servicios/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const deleteServicio = (id) => apiClient.delete(`/servicios/${id}`);
export const getServiciosPublicos = (doctorId) => apiClient.get(`/servicios/publico/${doctorId}`);